import { MessageDto } from '@app/data/dtos/message/message.dto';
import { Message } from '@app/entities/models/message/message.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapMessage: MapFromFn<MessageDto, Message> = (value) =>
  Builder.forModel(Message)
    .id(value.id)
    .message_type(value.message_type)
    .subject(value.subject)
    .creation_date(value.creation_date)
    .text(value.text)
    .build();

export const mapMessageData: MapFromFn<MessageDto[], Message[]> = (value) => value.map(mapMessage);
